<!--/////////////////////////////////////////////////////////////////////////////////////////-->
<div *ngIf="tk === 'pruebas'" class="pruebas">PRUEBAS</div>
<!--/////////////////////////////////////////////////////////////////////////////////////////-->
<nav id="navbar" class="navegador">
    <a class="logo" href="https://triidy.com">
        <img class="img-log" src="https://triidy.com/wp-content/uploads/2022/08/logo.svg" alt="Triidy">
    </a>
    <!-- <a class="l-menu" routerLink="/somos-triidy">Somos Triidy</a>
    <a class="l-menu" routerLink="/beneficios">Beneficios</a>
    <a class="l-menu" href="https://triidy.co/" target="_blank">Blog</a>
    <a class="l-menu" routerLink="/ayuda">Ayuda</a> -->
    <div class="l-menu downl">Descargas
        <div class="subnav">
            <img class="" (click)="descargaAnd()"
                src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/GooglePlay-new.png" alt="">
            <img class="" (click)="descargaWin()"
                src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Windows-new.png" alt="">
        </div>
    </div>
    <div class="right">
        <a class="r-menu" routerLink="/iniciar-sesion">Iniciar Sesión</a>
        <!-- <a class="r-menu btn" routerLink="/registrate">Registrarme</a> -->
        <a class="r-menu btn" (click)="clickM()">Registrarme</a>
    </div>
</nav>

<nav class="mobile" role="navigation">
    <div class="logo" routerLink="">
        <img class="img-log" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Logo_Triidy_3.0.svg"
            alt="Triidy">
        <span class="log-name">Triidy</span>
    </div>
    <div id="menuToggle" #sidenav>
        <input type="checkbox" id="checkMenu" />
        <span></span>
        <span class="span-middle"></span>
        <span></span>
        <ul id="menu">
            <li><a class="s-men" routerLink="/somos-triidy" routerLinkActive="active">Somos Triidy</a>
            </li>
            <li><a class="s-men" routerLink="/beneficios" routerLinkActive="active">Beneficios</a></li>
            <li><a class="s-men" href="https://triidy.co/" target="_blank">Blog</a></li>
            <li><a class="s-men" routerLink="/ayuda" routerLinkActive="active">Ayuda</a></li>
            <li><a class="sesion s-men dropdown-toggle" d="dropdownMenuLink" data-toggle="dropdown">Descargas</a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <img class="" (click)="descargaAnd()"
                        src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/GooglePlay-new.png" alt="">
                    <img class="" (click)="descargaWin()"
                        src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Windows-new.png" alt="">
                </div>
            </li>
        </ul>
    </div>
    <div class="butt">
        <a class="s-men" routerLink="/iniciar-sesion" routerLinkActive="active">Iniciar Sesión</a>
    </div>
</nav>